// extracted by mini-css-extract-plugin
module.exports = {"sourceDialog":"MemberNew_source-dialog_2i0x3","dialogTitle":"MemberNew_dialog-title_3NnNk","itemIcon":"MemberNew_item-icon_1r9zy"};